// MalaysiaPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import DrpEduNavbar from "../../components/DrpEduNavbar";

const MalaysiaPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in Malaysia</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Basic Information</h2>
          <ul>
            <li>
              <strong>Degree:</strong> Doctor of Philosophy (PhD)
            </li>
            <li>
              <strong>Duration:</strong> 3 to 5 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>
                  Master’s degree in a relevant field (some may accept
                  exceptional Bachelor's Honours)
                </li>
                <li>Good academic record and a viable research proposal</li>
                <li>
                  English proficiency (IELTS/TOEFL) required for international
                  students (e.g., IELTS 6.0 or higher)
                </li>
              </ul>
            </li>
            <li>
              <strong>Medium of Instruction:</strong> English (common for PhD
              programs)
            </li>
            <li>
              <strong>Admission Process:</strong>
              <ul>
                <li>
                  Online application with proposal, academic documents,
                  references, and interview
                </li>
              </ul>
            </li>
            <li>
              <strong>Funding Options:</strong>
              <ul>
                <li>Malaysian International Scholarship (MIS)</li>
                <li>University scholarships & research assistantships</li>
                <li>
                  Monthly stipend: ~MYR 1,800–3,000 (USD 400–650) depending on
                  funding
                </li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Basic Information</h2>
          <ul>
            <li>
              <strong>Position:</strong> Postdoctoral Research Fellow / Research
              Officer
            </li>
            <li>
              <strong>Duration:</strong> 1 to 3 years, renewable
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Completed PhD in a relevant area</li>
                <li>Strong publication record (Scopus/ISI indexed journals)</li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Funded by Ministry of Higher Education (MOHE), universities,
                  or external grants
                </li>
                <li>Salary: MYR 5,000–8,000/month (USD 1,000–1,700)</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in Malaysia</h2>
          <ol>
            <li>
              <strong>University of Malaya (UM), Kuala Lumpur</strong> –
              Malaysia’s oldest and highest-ranked university; top research
              output in engineering, science, medicine, and humanities.
            </li>
            <li>
              <strong>Universiti Putra Malaysia (UPM), Serdang</strong> –
              Excellent for agriculture, biotechnology, and life sciences;
              strong research and government funding support.
            </li>
            <li>
              <strong>Universiti Kebangsaan Malaysia (UKM), Bangi</strong> –
              Focus areas include public health, social science, and technology;
              offers English-medium PhD and postdoc programs.
            </li>
            <li>
              <strong>Universiti Sains Malaysia (USM), Penang</strong> – Leading
              in science, health, engineering, and sustainability research;
              strong international ties.
            </li>
            <li>
              <strong>Universiti Teknologi Malaysia (UTM), Johor Bahru</strong>{" "}
              – Best for engineering, computer science, and architecture; hosts
              international research collaborations.
            </li>
            <li>
              <strong>Monash University Malaysia (Branch Campus)</strong> –
              Australian university with strong research programs;
              international-standard facilities and PhD/postdoc opportunities.
            </li>
            <li>
              <strong>Taylor’s University, Selangor</strong> – Private
              university with rising research profile; offers fully English PhD
              programs with industry focus.
            </li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default MalaysiaPhD;
